module.exports = __webpack_public_path__ + "img/5.2f7bf61e.png";